import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import Blog from "./sections/Blog";
import Intelligence from "./sections/Intelligence";
import Subscribe from "./sections/Subscribe";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <Blog />
      <Intelligence />
      <Subscribe />
      <Footer />
    </div>;
}